import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const BoxCheckboxContainerStyled = styled(Box, {
  name: 'BoxCheckboxContainerStyled',
})(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
